// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brokerTable-container {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  /* width: 100%; */
}

.brokerTable-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: -0.4px;
  min-height: 24px;
}

.brokerTable-title {
  display: flex;
  min-width: 95px;
  max-width: 95px;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
}

.brokerTable-title-strongBuy {
  color: var(--heatmap-up-5);
}

.brokerTable-title-buy {
  color: var(--heatmap-up-2);
}

.brokerTable-title-hold {
  color: var(--heatmap-no-chg);
}

.brokerTable-title-reduce {
  color: var(--heatmap-down-3);
}

.brokerTable-title-sell {
  color: var(--heatmap-down-5);
}

.brokerTable-total {
  display: flex;
  min-width: 33px;
  max-width: 35px;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  color: var(--text-primary, #1e1f2f);
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}

.brokerTable-icon-container {
  /* white-space: nowrap; */
}

.brokerTable-icon {
  &.strongBuy {
    path {
      fill: var(--heatmap-up-5);
    }
  }

  &.buy {
    path {
      fill: var(--heatmap-up-2);
    }
  }

  &.hold {
    path {
      fill: var(--heatmap-no-chg);
    }
  }

  &.reduce {
    path {
      fill: var(--heatmap-down-3);
    }
  }

  &.sell {
    path {
      fill: var(--heatmap-down-5);
    }
  }
}

.brokerTable-line {
  border: 1px dotted var(--border-tertiary);
  width: -webkit-fill-available;
}

@container (min-width: 768px) {
  .brokerRating-card-container {
    padding-bottom: 24px;
  }

  .brokerTable-container {
    min-width: 328px;
    max-width: 328px;
    padding: 0px 0px 0px 24px;
  }
}

@container (min-width: 1024px) {
  .brokerTable-container {
    flex-direction: column;
    padding-top: 20px;
    padding-left: 48px;
  }

  .brokerRating-chart-group {
    padding-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/BrokerTable/BrokerTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,2BAA2B;IAC7B;EACF;AACF;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".brokerTable-container {\n  display: flex;\n  padding: 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  /* width: 100%; */\n}\n\n.brokerTable-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: -0.4px;\n  min-height: 24px;\n}\n\n.brokerTable-title {\n  display: flex;\n  min-width: 95px;\n  max-width: 95px;\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.brokerTable-title-strongBuy {\n  color: var(--heatmap-up-5);\n}\n\n.brokerTable-title-buy {\n  color: var(--heatmap-up-2);\n}\n\n.brokerTable-title-hold {\n  color: var(--heatmap-no-chg);\n}\n\n.brokerTable-title-reduce {\n  color: var(--heatmap-down-3);\n}\n\n.brokerTable-title-sell {\n  color: var(--heatmap-down-5);\n}\n\n.brokerTable-total {\n  display: flex;\n  min-width: 33px;\n  max-width: 35px;\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n  color: var(--text-primary, #1e1f2f);\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.brokerTable-icon-container {\n  /* white-space: nowrap; */\n}\n\n.brokerTable-icon {\n  &.strongBuy {\n    path {\n      fill: var(--heatmap-up-5);\n    }\n  }\n\n  &.buy {\n    path {\n      fill: var(--heatmap-up-2);\n    }\n  }\n\n  &.hold {\n    path {\n      fill: var(--heatmap-no-chg);\n    }\n  }\n\n  &.reduce {\n    path {\n      fill: var(--heatmap-down-3);\n    }\n  }\n\n  &.sell {\n    path {\n      fill: var(--heatmap-down-5);\n    }\n  }\n}\n\n.brokerTable-line {\n  border: 1px dotted var(--border-tertiary);\n  width: -webkit-fill-available;\n}\n\n@container (min-width: 768px) {\n  .brokerRating-card-container {\n    padding-bottom: 24px;\n  }\n\n  .brokerTable-container {\n    min-width: 328px;\n    max-width: 328px;\n    padding: 0px 0px 0px 24px;\n  }\n}\n\n@container (min-width: 1024px) {\n  .brokerTable-container {\n    flex-direction: column;\n    padding-top: 20px;\n    padding-left: 48px;\n  }\n\n  .brokerRating-chart-group {\n    padding-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
